import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_CONTEXT_ADDED_TYPES = ['asset', 'board'] as const;

export type WorkspaceAgentContextAddedType = (typeof WORKSPACE_AGENT_CONTEXT_ADDED_TYPES)[number];

export const WORKSPACE_AGENT_CONTEXT_ADDED_METHODS = ['keyboard', 'button'] as const;

export type WorkspaceAgentContextAddedMethod = (typeof WORKSPACE_AGENT_CONTEXT_ADDED_METHODS)[number];

const META: Meta = {
  description: 'The user picks a mentionable row from the composer @ context picker',
  name: 'agent_context_added',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The type of context added',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_CONTEXT_ADDED_TYPES],
    },
    {
      description: 'Whether the row was picked via keyboard or pointer',
      name: 'method',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_CONTEXT_ADDED_METHODS],
    },
  ],
};

export default META;
